export default {
  /** api 관련 */
  prefix: '',
  versioning: 'v1',
}

export const PAGE_SIZE = 20
export const PAGE_PARAM = 'page'
